module.exports = __webpack_public_path__ + "img/requestsupport-blue.ec478011.svg";